import { render } from "./AllowedPrincipals.vue?vue&type=template&id=5edfeb6e&scoped=true"
import script from "./AllowedPrincipals.vue?vue&type=script&lang=js"
export * from "./AllowedPrincipals.vue?vue&type=script&lang=js"

import "./AllowedPrincipals.vue?vue&type=style&index=0&id=5edfeb6e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5edfeb6e"]])

export default __exports__